import { registerInit } from "./initRegistry";

export function initCart(): void {

}

registerInit(initCart);